import React from "react";
import { ExternalViewSelector } from "../components/ExternalViewSelector";
import { useExternalDesignContext } from "../contexts/external-design.context";

export function ExternalViewSelectorWrapper() {
  const { views, selectedView, selectView, config } =
    useExternalDesignContext();
  return (
    <ExternalViewSelector
      views={views}
      onStyleViewSelect={selectView}
      isCurrentView={(v) => v.id === selectedView.id}
      accentColor={config?.theme?.accentColor}
      padding={config?.layout?.paddingViewSelector}
    />
  );
}
